import React from "react";

export default function About(props){
    return(

        <>
        <div className="container mb-5" style={{backgroundColor: props.mode==='dark'?'#042743':'white',color: props.mode==='dark'?'white':'#042743'}}>
            <h2>Analyze your text</h2>
            <p>TextUtils give you a way to analyze your text quickly and efficiently. Be it word count and character count</p><br />
            <h2>Free to use </h2>
            <p>TextUtil is free character counter tool that provides instant character count & word count statistics for given text.
               <br /> TextUtil reports the number of Words and characters thus it is suitable for writting text with word/character limit.
            </p>
        </div><br /><br />
        <div className="container" style={{backgroundColor: props.mode==='dark'?'#042743':'white',color: props.mode==='dark'?'white':'#042743'}}>
             <a href="https://sandeepkumarsidha.netlify.app/"><img src="about-me.jpg" className="rounded float-end" alt="..."/></a>
            <h3>Contact Me</h3><br />
            <p>Sandeep Kumar</p>
            <p>Mobile No: 7830117341</p>
            <p>Gmail: sandeepwzj001@gmail.com</p>
            <a href="https://instagram.com/sandeep_7.8?igshid=NTA5ZTk1NTc=" style={{color: "green",textDecoration: 'none'}}><p>Instagram</p></a>
            <a href="https://www.linkedin.com/in/sandeep-kumar-717b35226" style={{color: "green",textDecoration: 'none'}}><p>Linkedin</p></a>
            <a href="https://www.facebook.com/Sandeepkumar7830?mibextid=ZbWKwL" style={{color: "green",textDecoration: 'none'}}><p>Facebook</p></a>
            <a href="https://twitter.com/sandeepsingh7_8?t=RiIORblYV0H32tve2I28cw&s=08" style={{color: "green",textDecoration: 'none'}}><p>Twitter</p></a>

        </div>
        </>
    );
}

